"use client";

import Image from "next/image";
import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { routes } from "@/lib/routes";

export default function HomeSchedulingSection() {
  const { t } = useTranslation();

  const primaryCta =
    "inline-flex min-h-11 items-center justify-center gap-2 rounded-xl bg-white px-6 py-3 text-sm font-semibold uppercase tracking-wide text-primary shadow-lg transition hover:bg-slate-100 active:scale-[0.98] sm:px-7";
  const secondaryCta =
    "inline-flex min-h-11 items-center justify-center gap-2 rounded-xl border border-white/80 bg-white/10 px-6 py-3 text-sm font-semibold uppercase tracking-wide text-white backdrop-blur-sm transition hover:bg-white/20 active:scale-[0.98] sm:px-7";

  return (
    <section className="relative isolate flex min-h-[min(52vh,440px)] items-center overflow-hidden py-16 text-white sm:py-20 md:py-24">
      <Image
        src="/new/DSC06258.jpeg"
        alt={t("images.homeScheduling")}
        fill
        sizes="100vw"
        className="object-cover object-[50%_24%]"
        quality={80}
        loading="lazy"
      />
      <div
        className="absolute inset-0 bg-gradient-to-br from-[#0f2458]/95 via-primary-strong/90 to-[#152a6b]/88"
        aria-hidden
      />
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_80%_60%_at_50%_0%,rgba(255,255,255,0.12),transparent_55%)]" aria-hidden />

      <div className="relative z-10 mx-auto flex w-full max-w-3xl flex-col items-center gap-6 px-4 text-center md:max-w-4xl md:gap-8 md:px-6">
        <h2
          className="text-balance text-2xl font-black tracking-tight sm:text-3xl md:text-4xl md:leading-tight"
          suppressHydrationWarning
        >
          {t("home.schedulingTitle")}
        </h2>
        <p
          className="max-w-2xl text-pretty text-sm leading-relaxed text-white/90 sm:text-base md:text-lg"
          suppressHydrationWarning
        >
          {t("home.schedulingDesc")}
        </p>
        <div className="flex w-full max-w-lg flex-col items-stretch gap-3 sm:max-w-none sm:flex-row sm:flex-wrap sm:justify-center sm:gap-4">
          <Link href={routes.listing} className={primaryCta}>
            <span suppressHydrationWarning>{t("home.bookTraining")}</span>
            <ArrowRight className="h-4 w-4 shrink-0" aria-hidden />
          </Link>
          <Link href={routes.pricing} className={secondaryCta}>
            <span suppressHydrationWarning>{t("home.viewPricingPlan")}</span>
            <ArrowRight className="h-4 w-4 shrink-0" aria-hidden />
          </Link>
        </div>
      </div>
    </section>
  );
}
